import {Button} from "../ui/button";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";


interface navButtonProps  {
    text?: string | null
}

export function GoToVEButton({text}: navButtonProps){
    const navigate = useNavigate();
    const { project_id } = useParams<string>();
    return <Button
        variant="outline"
        onClick={() => navigate(`/project/${project_id}/ve`)}
        >
        {text? text : "More"}
    </Button>
}


export function GoToQAButton({text}: navButtonProps){
    const navigate = useNavigate();
    const { project_id } = useParams<string>();
    return <Button
        variant="outline"
        onClick={() => navigate(`/project/${project_id}/qa`)}
        >
        {text? text : "More"}
    </Button>
}

export function GoToScopesButton({text}: navButtonProps){
    const navigate = useNavigate();
    const { project_id } = useParams<string>();
    return <Button
        variant="outline"
        onClick={() => navigate(`/project/${project_id}/scopes`)}
        >
        {text? text : "More"}
    </Button>
}


